import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useLocation, Link, useNavigate, useParams } from "react-router-dom";
import { DataContext } from "./DataContext";

const ListPage = () => {
  const { globalData, catData } = useContext(DataContext);
  const [listData, setListData] = useState([]);
  const [Ids, setIds] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { cardData } = location.state || {};
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const [filters, setFilters] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [temporaryFilters, setTemporaryFilters] = useState([]);

  const [districts, setDistricts] = useState([]);
  const [districtFilters, setDistrictFilters] = useState([]);
  const [temporaryDistrictFilters, setTemporaryDistrictFilters] = useState([]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const recordsPerPage = 7;
  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  let idInt = parseInt(id);
  const foundObject = catData.find((item) => item.id === idInt);

  useEffect(() => {
    setLoading(true);
    setIds(id);
    const queryParams = new URLSearchParams(location.search);
    const page = Number(queryParams.get("page")) || 1;
    // const filterCategory = queryParams.get("filter_category") || "";
    let selectedFilterIds = appliedFilters.join(",");
    let selectedDistrictIds = districtFilters.join(",");

    setCurrentPage(page);
    const url = `https://cms.ctdestinationhartford.com/wp-json/wp/v2/posts?categories=${id}&per_page=${recordsPerPage}&page=${page}&orderby=title&order=asc${
      selectedFilterIds ? `&filter_category=${selectedFilterIds}` : ""
    }${
      selectedDistrictIds
        ? `&hartford_businesses_by_districts=${selectedDistrictIds}`
        : ""
    }`;

    //alert(url);
    axios
      .get(url)
      .then((response) => {
        const sortedData = response.data.sort((a, b) =>
          a.title.rendered.localeCompare(b.title.rendered)
        );
        setListData(sortedData);
        setTotalRecords(response.headers.get("x-wp-total") || 0);
        setLoading(false);
      })
      .catch((error) => {
        setError(error.message);
        console.log("error", error);
        setLoading(false);
      });
  }, [id, appliedFilters, districtFilters, location.search]);

  const decodeEntities = (encodedString) => {
    const parser = new DOMParser();
    const dom = parser.parseFromString(
      `<!doctype html><body>${encodedString}`,
      "text/html"
    );
    return dom.body.textContent;
  };

  const openSidebar = () => {
    setIsSidebarOpen(true);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const response = await axios.get(
          `https://cms.ctdestinationhartford.com/wp-json/custom/v1/filter-categories?category_id=${id}&orderby=title&order=asc`
        );
        setFilters(response.data);
      } catch (error) {
        console.error("Error fetching filters:", error);
      }
    };
    fetchFilters();
  }, [id]);

  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const response = await axios.get(
          `https://cms.ctdestinationhartford.com/wp-json/custom/v1/hartford_businesses_by_districts?category_id=${id}`
        );
        setDistricts(response.data);
      } catch (error) {
        console.error("Error fetching districts:", error);
      }
    };
    fetchDistricts();
  }, [id]);

  const toggleFilterSelection = (filterId) => {
    setTemporaryFilters((prevFilters) => {
      if (prevFilters.includes(filterId)) {
        return prevFilters.filter((id) => id !== filterId);
      } else if (prevFilters.length < 3) {
        return [...prevFilters, filterId];
      } else {
        setShowModal(true);
        return prevFilters;
      }
    });
  };

  const toggleFilterDistrictionSelection = (filterId) => {
    setTemporaryDistrictFilters((prevFilters) => {
      if (prevFilters.includes(filterId)) {
        return prevFilters.filter((id) => id !== filterId);
      } else if (prevFilters.length < 3) {
        return [...prevFilters, filterId];
      } else {
        setShowModal(true);
        return prevFilters;
      }
    });
  };

  // Apply filters on button click
  const applyFilters = () => {
    setAppliedFilters([...temporaryFilters]); // Apply selected filters
    setCurrentPage(1);
    const queryParams = new URLSearchParams(location.search);
    queryParams.set("page", 1);
    navigate(`?${queryParams.toString()}`);
  };

  // Apply filters on button click
  const applyDistrictFilters = () => {
    setDistrictFilters([...temporaryDistrictFilters]); // Apply selected filters
    setCurrentPage(1);
    const queryParams = new URLSearchParams(location.search);
    queryParams.set("page", 1);
    navigate(`?${queryParams.toString()}`);
  };

  // Handle offcanvas close without applying filters
  const handleTemporaryFilters = () => {
    setTemporaryFilters(appliedFilters); // Reset temporary filters to confirmed filters
    setTemporaryDistrictFilters(districtFilters);
  };

  const removeFilter = (filterId) => {
    setAppliedFilters((prevFilters) =>
      prevFilters.filter((id) => id !== filterId)
    );
    setTemporaryFilters(appliedFilters);
  };

  const removeDistrictFilter = (filterId) => {
    setDistrictFilters((prevFilters) =>
      prevFilters.filter((id) => id !== filterId)
    );
    setTemporaryDistrictFilters(appliedFilters);
  };

  const clearAllFilters = () => {
    setAppliedFilters([]); // Clear applied filters for API call
    setDistrictFilters([]); // Clear applied filters for API call
    setTemporaryFilters([]); // Clear temporary filters
    setCurrentPage(1); // Reset to the first page
  };

  const handleViewDetails = (card, id) => {
    navigate(`/detail/${card.id}?page=${currentPage}`, {
      state: { cardData: card, savedFilters: appliedFilters, mainId: Ids },
    });
  };

  const handleListDetails = (card) => {
    closeSidebar();
    navigate(`/list/${card.id}`, { state: { cardData: card } });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    const queryParams = new URLSearchParams(location.search);
    queryParams.set("page", page);
    navigate(`?${queryParams.toString()}`);
  };

  const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const getPages = () => {
      const pages = [];
      const ellipsis = "...";

      if (totalPages <= 5) {
        // Show all pages if totalPages is 6 or less
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        // Always include the first page
        pages.push(1);

        // Handle ranges for larger totalPages
        if (currentPage <= 4) {
          for (let i = 2; i <= Math.min(4, totalPages - 1); i++) {
            pages.push(i);
          }
          pages.push(ellipsis);
          pages.push(totalPages);
        } else if (currentPage >= totalPages - 3) {
          pages.push(ellipsis);
          for (let i = totalPages - 4; i <= totalPages; i++) {
            pages.push(i);
          }
        } else {
          pages.push(ellipsis);
          for (let i = currentPage - 3; i <= currentPage + 3; i++) {
            pages.push(i);
          }
          pages.push(ellipsis);
          pages.push(totalPages);
        }
      }

      return pages;
    };

    if (totalPages === 1) return null;

    const handlePageChange = (page) => {
      if (page !== "..." && page !== currentPage) {
        onPageChange(page);
      }
    };

    return (
      <nav aria-label="Page navigation">
        <ul className="pagination justify-content-center">
          {/* Previous Button */}
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(currentPage - 1)}
              onTouchStart={() => handlePageChange(currentPage - 1)}
            >
              Previous
            </button>
          </li>

          {/* Dynamic Page Numbers */}
          {getPages().map((page, index) => (
            <li
              key={index}
              className={`page-item ${currentPage === page ? "active" : ""} ${
                page === "..." ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => handlePageChange(page)}
                onTouchStart={() => handlePageChange(page)}
                disabled={page === "..."}
              >
                {page}
              </button>
            </li>
          ))}

          {/* Next Button */}
          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
          >
            <button
              className="page-link"
              onClick={() => handlePageChange(currentPage + 1)}
              onTouchStart={() => handlePageChange(currentPage + 1)}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    );
  };
  if (loading) return;
  if (error) return;

  return (
    <div>
      {/* <!-- Header Section --> */}
      <div className="top-section light-purple-bg text-center">
        <Link to="/">
          <img
            src={globalData?.acf?.logo_image || ""}
            alt="Logo"
            className="img-fluid"
          />
        </Link>
      </div>
      {/* <!-- Logo and Welcome Section --> */}
      <div className="welcome-main-section">
        <div className="welcome-section text-center full-width">
          <h2 className="my-3 heading-text">
            {decodeEntities(foundObject?.name)}
          </h2>
          <p className="lead p-text">
            {decodeEntities(foundObject?.acf?.description)}
          </p>
        </div>

        {/* <!-- Image Card Section --> */}
        <div className="breadcrumb-section page-container">
          <div className="row mb-3">
            {/* <!-- Breadcrumb-like pagination on the left --> */}
            <nav
              style={{ "--bs-breadcrumb-divider": ">" }}
              aria-label="breadcrumb"
              className="col-md-10 d-flex align-items-center justify-content-between"
            >
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/">Back to Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <Link className="disabled-link fw-bold">
                    {decodeEntities(foundObject?.name)}
                  </Link>
                </li>
              </ol>
            </nav>

            {/* <!-- Filter button on the right --> */}
            {filters?.length > 1 || districts?.length > 1 ? (
              <div className="col-md-2 d-flex align-items-center justify-content-end">
                {/* Applied Filter Buttons */}
                <div className="applied-filters">
                  {appliedFilters.map((filterId) => {
                    const filter = filters.find((f) => f.term_id === filterId);
                    return (
                      <button
                        key={filterId}
                        className="btn btn-outline-primary"
                        onClick={() => {
                          removeFilter(filterId);
                        }}
                      >
                        {decodeEntities(filter?.name)} <span>&times;</span>
                      </button>
                    );
                  })}

                  {districtFilters.map((filterId) => {
                    const filter = districts.find(
                      (f) => f.term_id === filterId
                    );
                    return (
                      <button
                        data-type="district"
                        key={filterId}
                        className="btn btn-outline-primary"
                        onClick={() => {
                          removeDistrictFilter(filterId);
                        }}
                      >
                        {decodeEntities(filter?.name)} <span>&times;</span>
                      </button>
                    );
                  })}
                </div>
                <button
                  className="btn btn-primary filter-btn"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#filterOffcanvas"
                  aria-controls="filterOffcanvas"
                  onClick={handleTemporaryFilters}
                  onTouchStart={handleTemporaryFilters}
                >
                  Filter <img src="/images/filter.svg" alt="filter" />
                </button>
              </div>
            ) : null}
          </div>

          {/* <!-- Side popup (offcanvas) --> */}
          <div
            className="offcanvas offcanvas-end filter-section"
            tabIndex="-1"
            id="filterOffcanvas"
            aria-labelledby="filterOffcanvasLabel"
            data-bs-scroll="true"
            data-bs-backdrop="false"
            // onHide={handleTemporaryFilters}
          >
            <div className="offcanvas-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                onClick={handleTemporaryFilters}
                onTouchStart={handleTemporaryFilters}
              ></button>
            </div>
            <div className="offcanvas-body" style={{ height: "100%" }}>
              <p className="p-text">{globalData?.acf?.filter_text_}</p>

              <p className="filter-header">Choose up to three (3) districts</p>
              <div className="filter-buttons" style={{ margin: "0 0 40px" }}>
                {districts?.map((district) => (
                  <button
                    data-filter="districts"
                    key={district?.term_id}
                    className={`btn ${
                      temporaryDistrictFilters.includes(district.term_id)
                        ? "btn-primary selected" // Selected state
                        : "btn-outline-primary" // Unselected state
                    }`}
                    onTouchEnd={() =>
                      toggleFilterDistrictionSelection(district.term_id)
                    }
                  >
                    {decodeEntities(district?.name)}
                  </button>
                ))}
              </div>

              <p className="filter-header">Choose up to three (3) categories</p>
              <div className="filter-buttons" style={{ margin: "0 0 40px" }}>
                {filters?.map((filter) => (
                  <button
                    key={filter?.term_id}
                    className={`btn ${
                      temporaryFilters.includes(filter.term_id)
                        ? "btn-primary selected" // Selected state
                        : "btn-outline-primary" // Unselected state
                    }`}
                    onClick={() => toggleFilterSelection(filter.term_id)}
                  >
                    {decodeEntities(filter?.name)}
                  </button>
                ))}

                {/* Modal for filter limit warning */}
                <div
                  className="modal fade show"
                  style={{ display: showModal ? "block" : "none" }}
                  tabIndex="-1"
                  role="dialog"
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title free-txt">
                          Selection Limit Reached
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowModal(false)}
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        <p className="text-danger">
                          You can select up to 3 categories only.
                        </p>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-outline-primary"
                          onClick={() => setShowModal(false)}
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-center filter-buttons">
                <button
                  type="button"
                  className="btn btn-outline-primary rounded-pill apply-btn"
                  onClick={() => {
                    applyFilters();
                    applyDistrictFilters();
                  }}
                  // onTouchStart={() => {
                  //   applyFilters();
                  //   applyDistrictFilters();
                  // }}
                  data-bs-dismiss="offcanvas"
                >
                  APPLY FILTERS
                </button>
                {appliedFilters.length > 0 && (
                  <button
                    type="button"
                    className="btn btn-outline-primary rounded-pill apply-btn"
                    onClick={clearAllFilters}
                    // onTouchStart={clearAllFilters}
                  >
                    RESET FILTERS
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="page-content-container">
          {/* <!-- card --> */}
          {listData?.length === 0 ? (
            <div className="mt-3 page-container">
              <div className="card">
                <div className="card-body text-center accordion-box">
                  <h5 className="secodary-text">
                    No {cardData?.name || " Categoery"} info available
                  </h5>
                </div>
              </div>
            </div>
          ) : (
            listData?.map((card) => (
              <div className="mt-3 page-container" key={card.id}>
                <div className="card">
                  <div
                    className="link-text"
                    style={{ cursor: "pointer" }}
                    onClick={() => card && handleViewDetails(card)}
                  >
                    <div className="card-body accordion-box">
                      <div className="row">
                        <div className="col-8">
                          <h5 className="secodary-text">
                            {decodeEntities(card?.title?.rendered) || ""}
                          </h5>
                        </div>
                        <div className="col-4 text-right d-flex justify-content-end dollar">
                          <p className="secodary-text">
                            {card?.acf?.price ? `${card?.acf?.price}` : ""}
                          </p>
                        </div>
                      </div>
                      <div className="row mt-3 align-items-center">
                        <div className="col-10 free-txt d-flex align-items-center">
                          {card?.acf?.category_icon ? (
                            <img
                              src={card?.acf?.category_icon || ""}
                              alt="BBQ Icon"
                              className="bbq-icon"
                            />
                          ) : null}{" "}
                          {card?.filter_category_names
                            ?.slice()
                            .sort((a, b) => a.localeCompare(b))
                            .map((item, index, array) => (
                              <span style={{ marginRight: "5px" }} key={index}>
                                {decodeEntities(item)}
                                {index < array.length - 1 ? " | " : ""}
                              </span>
                            ))}{" "}
                          <span className="walkable walk-btn">
                            {card?.acf?.tags || ""}
                          </span>
                          <span className="walkable walk-btn">
                            {card?.acf?.subtitle || ""}
                          </span>
                          {/* <span className="walkable walk-btn">{card.id}</span> */}
                        </div>
                        <div className="col-2 text-right d-flex justify-content-end stamp-img">
                          {card?.acf?.passport_type ? (
                            <img
                              src={card?.acf?.passport_type}
                              alt="passport_type"
                              className="img-fluid d-flex justify-content-end"
                            />
                          ) : null}
                          {card?.acf?.passport_type_2 ? (
                            <img
                              src={card?.acf?.passport_type_2}
                              alt="passport_type"
                              className="img-fluid d-flex justify-content-end"
                            />
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
        {/* Pagination Controls */}
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>
      {/* <!-- Next Section with 3 Columns --> */}
      <div className="footer-section">
        <div className="row full-width footer-back">
          {/* <!-- First Column: Image --> */}
          <div className="lf-qr col-md-4 d-flex align-items-center justify-content-start">
            {/* <img
              src={globalData?.acf?.hartford_passport_program_qr || ""}
              alt="qr"
              className="img-fluid"
            />
            <span className="hp-qrcode">HARTFORD PASSPORT PROGRAM</span> */}
            <span className="digital-market">Digital Marketing by The Rebellion Group</span>
          </div>
          {/* <!-- Second Column: Icon --> */}
          <div className="col-md-4 d-flex align-items-center justify-content-center">
            <Link to="/">
              <img src="/images/home.svg" alt="home" className="img-fluid" />
            </Link>
          </div>
          {/* <!-- Third Column: Button --> */}
          <div className="col-md-4 cat-btn">
            <button
              className="btn btn-primary menu-btn"
              onClick={openSidebar} // Open the sidebar
              // onTouchstart={openSidebar}
            >
              CATEGORY MENU
              <img src={"/images/arrow.svg"} alt="arrow" />
            </button>
          </div>
        </div>
      </div>

      {/* Overlay to close the sidebar */}
      {isSidebarOpen && (
        <div
          className="overlay sidebar-close"
          onClick={closeSidebar}
          // onTouchStart={closeSidebar}
        ></div>
      )}

      {/* Sidebar Offcanvas */}
      <div
        className={`offcanvas offcanvas-end ${isSidebarOpen ? "show" : ""}`}
        tabIndex="-1"
        id="sidebarMenu"
        aria-labelledby="sidebarMenuLabel"
        style={{
          visibility: isSidebarOpen ? "visible" : "hidden",
          zIndex: 1045, // Ensure it is above the overlay
        }}
      >
        <div className="offcanvas-header">
          <h5 id="sidebarMenuLabel" className="secodary-text">
            Category Menu
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={closeSidebar} // Close the sidebar on button click
            //  onTouchStart={closeSidebar}
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <ul className="list-group">
            {catData?.map((item) => (
              <li
                className="list-group-item"
                onClick={() => handleListDetails(item)}
                // onTouchStart={() => handleListDetails(item)}
                key={item.id}
                role="button"
              >
                {item.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ListPage;
